import React from "react";
import {Button, Input, Modal, Popover, Table} from "antd";
import {AddWasteProfile} from "./AddWasteProfile";

const content = (
    <div className="action-column action-dropdown">
        <a title="View"><i className="fa fa-eye"/></a>
        <a title="Edit"><i className="fa fa-pencil"/></a>
        <a title="Print"><i className="icon-printer"/></a>
    </div>
);

export class ShowWasteProfile extends React.Component {
    state = {
        AddWasteProfile: false,
    };
    columns = [
        {
            title: 'Action',
            render: item =>
                <Popover placement="right" content={content} trigger="hover">
                    <a className="action-dropdown" href="#"><i className="fa fa-ellipsis-h"/> </a>
                </Popover>
        }, {
            title: <span>Waste <br/> Stream</span>,
            dataIndex: 'ws_name',
            key: 'ws_name',
        }, {
            title: <span>Process <br/> Description</span>,
            dataIndex: 'description',
            key: 'description',
        }, {
            title: 'Composition',
            dataIndex: 'composition',
            key: 'composition',
        }, {
            title: <span>Physical <br/> Property</span>,
            dataIndex: 'property',
            key: 'property',
        }, {
            title: 'Color',
            dataIndex: 'color',
            key: 'color',
        }, {
            title: 'Order',
            dataIndex: 'order',
            key: 'order',
        }, {
            title: <span>Flash  Point <br/> (Actual)</span>,
            dataIndex: 'flash_point',
            key: 'flash_point',
        }, {
            title: 'pH',
            dataIndex: 'ph',
            key: 'ph',
        }, {
            title: <span>Total <br/> Halogen</span>,
            dataIndex: 'total_halogen',
            key: 'total_halogen',
        }, {
            title: 'PCB',
            dataIndex: 'pcb',
            key: 'pcb',
        }, {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        },];
    data = [{
        key: '1',
        ws_name: <span>C&D <br/><div className="id-gen">N816</div></span>,
        description: 'Demo',
        composition: <span>Sand <br/><div className="id-gen">100%</div></span>,
        property: 'Solid',
        color: 'Brown',
        order: 'Demo',
        flash_point: '<100F',
        ph: '7',
        total_halogen: '<100F',
        pcb: 'Yes',
        status: <span className="completed"><i className="fa fa-circle"/></span>
    }, {
        key: '2',
        ws_name: <span>C&D <br/><div className="id-gen">N816</div></span>,
        description: 'Demo',
        composition: <span>Sand <br/><div className="id-gen">100%</div></span>,
        property: 'Solid',
        color: 'Brown',
        order: 'Demo',
        flash_point: '<100F',
        ph: '7',
        total_halogen: '<100F',
        pcb: 'Yes',
        status: <span className="completed"><i className="fa fa-circle"/></span>
    }, {
        key: '3',
        ws_name: <span>C&D <br/><div className="id-gen">N816</div></span>,
        description: 'Demo',
        composition: <span>Sand <br/><div className="id-gen">100%</div></span>,
        property: 'Solid',
        color: 'Brown',
        order: 'Demo',
        flash_point: '<100F',
        ph: '7',
        total_halogen: '<100F',
        pcb: 'Yes',
        status: <span className="completed"><i className="fa fa-circle"/></span>
    }, {
        key: '4',
        ws_name: <span>C&D <br/><div className="id-gen">N816</div></span>,
        description: 'Demo',
        composition: <span>Sand <br/><div className="id-gen">100%</div></span>,
        property: 'Solid',
        color: 'Brown',
        order: 'Demo',
        flash_point: '<100F',
        ph: '7',
        total_halogen: '<100F',
        pcb: 'Yes',
        status: <span className="completed"><i className="fa fa-circle"/></span>
    }, {
        key: '5',
        ws_name: <span>C&D <br/><div className="id-gen">N816</div></span>,
        description: 'Demo',
        composition: <span>Sand <br/><div className="id-gen">100%</div></span>,
        property: 'Solid',
        color: 'Brown',
        order: 'Demo',
        flash_point: '<100F',
        ph: '7',
        total_halogen: '<100F',
        pcb: 'Yes',
        status: <span className="completed"><i className="fa fa-circle"/></span>
    }];

    showAddWasteProfile = (visible) => {
        this.setState({AddWasteProfile: visible})
    };

    render() {
        const {visible} = this.props;
        return (
            <Modal closable={false} centered visible={visible} onOk={() => this.props.onCancel()}
                   onCancel={() => this.props.onCancel()} width='86%'
                   className="view-data-modal view-hotsheet-mdl custom-header"
                   title={<div className="row m-0">
                       <div className="col-sm-6 col-12 view-modal-header">
                           <h3><span>Waste Profile Record</span></h3>
                       </div>
                       <div className="col-sm-6 col-12 view-modal-header text-right">
                           <a href="#"> <i className="icon-printer"/> </a>
                       </div>
                   </div>}>
                <div className="row mx-0 m-b-20">
                    <div className="col-sm-8 col-12">
                        <Input placeholder="Search Here"/>
                    </div>
                    <div className="col-sm-4 col-12">
                        <Button type={"primary"} onClick={() => this.showAddWasteProfile(true)} >Create Waste Profile</Button>
                    </div>
                </div>
                <div className="row mx-0">
                    <div className="col-12">
                        <div className="listing-table">
                            <Table className="responsive-table table table-hover waste-profile-tbl"
                                   columns={this.columns} dataSource={this.data}/>
                        </div>
                    </div>
                </div>
                <AddWasteProfile visible={this.state.AddWasteProfile} onCancel={() => this.showAddWasteProfile(false)}/>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/analytics/in_development/popups/ShowWasteProfile.jsx